import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import styles from './Badge.module.scss';

const Badge = ({
  children,
  onClick,
  link,
  position,
  content,
  className,
  parentType,
  highlighted
}) => {
  const navigate = useNavigate();
  const onBadgeClick = (event) => {
    if (link !== null) {
      navigate(link);
      return;
    }

    if (onClick !== null) {
      onClick(event);
    }
  };

  return (
    <span className={styles.wrapper}>
      <span
        className={cn(
          styles.badge,
          styles[position],
          styles[`${parentType}Position`],
          {
            [styles.clickable]: !(onClick === null && link === null),
            [styles.highlighted]: highlighted
          },
          className
        )}
        onClick={onBadgeClick}
      >
        {content}
      </span>
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  parentType: PropTypes.oneOf(['icon', 'text']),
  highlighted: PropTypes.bool,
  className: PropTypes.string
};

Badge.defaultProps = {
  link: null,
  onClick: null,
  position: 'right',
  parentType: 'text',
  highlighted: false,
  className: null
};

export default Badge;
